import dynamic from "next/dynamic";

import type { ModalProps } from "./modal.component";

export const Modal = dynamic<ModalProps>(
  () => import("./modal.component").then((mod) => mod.ModalWrapper),
  {
    ssr: false,
  },
);
